module.exports = __webpack_public_path__ + "static/img/02_marius_hirschel_cornelius_carstens.f7a9b66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/mh/02_marius_hirschel_cornelius_carstens.jpg
// module id = rFZ2
// module chunks = 1